import React from 'react';
import { Autoplay, Pagination, Navigation, Parallax } from "swiper/modules";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import './hero.css'

// Import your images here
import hero from '../../assets/images/city-palace-banner.jpg';
import heroImg02 from '../../assets/images/img04.png';
import mobileImage from '../../assets/images/city-palace.jpg';
import mobileImage2 from '../../assets/images/car-rental.jpg';
// import mobileImage3 from '../../assets/images/raj-tour4.jpg';
// import mobileImage4 from '../../assets/images/tour-img03.jpg';
// import mobileImage5 from '../../assets/images/short-tour6.jpg';
// import mobileImage6 from '../../assets/images/golden-tour2.jpg';
// import mobileImage7 from '../../assets/images/jodhpur.jpg';
// import heroImg03 from '../../assets/images/rajasthan-banner.png';
// import heroImg04 from '../../assets/images/same-day-banner.png';
// import heroImg05 from '../../assets/images/ranthambore-banner.png';
// import heroImg06 from '../../assets/images/varanasi-banner.png';
// import heroImg07 from '../../assets/images/jodhpur-banner.png';

// Initialize Swiper modules

const Hero = () => {
  const slides = [
    {
      img: hero,
      mobileImg: mobileImage,
      title: 'Jaipur Sightseeing Day Tour',
      description: 'A journey through history, culture, and architectural marvels',
      link: '/tour-packages/jaipur-tour-packages/jaipur-sightseeing-day-tour',
    },
    {
      img: heroImg02,
      mobileImg: mobileImage2,
      title: 'Affordable Car Rentals',
      description: 'Mountains, beaches, or hidden gems, your car awaits.',
      link: '/car-rental',
    },
    // {
    //   img: heroImg03,
    //   mobileImg: mobileImage3,
    //   title: 'Ultimate Rajasthan Tours',
    //   description: 'Explore the Mesmerizing Beauty of Rajasthan',
    //   link: '/tour-packages/rajasthan-tour-packages/ultimate-rajasthan-tour',
    // },
    // {
    //   img: heroImg04,
    //   mobileImg: mobileImage4,
    //   title: 'Same-Day Tours',
    //   description: "Experience India's Charm, One Full Day at a Time.",
    //   link: '/tour-packages/short-tour-packages/delhi-agra-jaipur-tour',
    // },
    // {
    //    img: heroImg05,
    //    mobileImg: mobileImage5,
    //    title: 'Explore Ranthanmore',
    //    description: "Golden Triangle & Ranthambore's roar!",
    //    link: '/tour-packages/golden-triangle-tours/golden-triangle-tour-with-ranthambore',
    //  },
    // {
    //   img: heroImg06,
    //   mobileImg: mobileImage6,
    //   title: 'Golden Triangle & Varanasi',
    //   description: "Marble, markets, mantras: Unforgettable India.",
    //   link: '/tour-packages/golden-triangle-tours/golden-triangle-tour-with-varanasi',
    // },
    // {
    //   img: heroImg07,
    //   mobileImg: mobileImage7,
    //   title: 'Explore Jodhpur',
    //   description: "Unforgettable India, palaces, desert escape.",
    //   link: '/tour-packages/short-tour-packages/delhi-agra-jaipur-tour',
    // },
  ];

  return (
    <>
      <Swiper
        style={{
          '--swiper-navigation-color': '#000',
          '--swiper-pagination-color': '#fff',
        }}
        speed={600}
        parallax={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Parallax, Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className={`rotate rotate-slide${index + 1}`}
              style={{
                backgroundImage: `url(${slide.img})`,
              }}
              data-swiper-parallax="-23%"
            ></div>
            <div className="tree__btn title" data-swiper-parallax="-300">
              {slide.title}
            </div>
            <div
              className="text"
              data-swiper-parallax="-100"
              style={{
                position: 'absolute',
                bottom: '40px',
                right: '30px',
                color: '#ff7e01',
                textDecoration: 'none',
                display: 'block', // Ensure the default display is set to block
              }}
            >
              <p className="desktop-only">{slide.description}</p>
            </div>
            <Link
              to={slide.link}
              className="trees__btn"
              style={{
                position: 'absolute',
                bottom: '40px',
                right: '20px',
                color: '#fff',
                textDecoration: 'none',
              }}
            >
              Explore Now
            </Link>
            <style>
              {`
                @media (max-width: 768px) {
                  .rotate-slide${index + 1} {
                    background-image: url('${slide.mobileImg}') !important;
                    background-size: cover;
                  }
                  .text {
                    display: none !important; 
                  }
                }
              `}
            </style>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Hero;
